import { Directive, ElementRef, PLATFORM_ID, afterNextRender, inject, input } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { computeFlipPosition } from './flip-position.util';

@Directive({
  selector: '[flipPosition]',
  standalone: true,
})
export class FlipPositionDirective {
  private elementRef = inject(ElementRef<HTMLElement>);
  private platformId = inject(PLATFORM_ID);

  flipPositionTrigger = input.required<HTMLElement | null>();
  flipPositionAlign = input<'left' | 'right'>('left');
  flipPositionMargin = input<number>(8);

  constructor() {
    afterNextRender(() => {
      if (!isPlatformBrowser(this.platformId)) return;
      this.applyPosition();
    });
  }

  private applyPosition(): void {
    const trigger = this.flipPositionTrigger();
    const host = this.elementRef.nativeElement;
    if (!trigger || !host) return;

    const triggerRect = trigger.getBoundingClientRect();
    const panelRect = host.getBoundingClientRect();

    const { vertical, horizontal } = computeFlipPosition(
      triggerRect,
      { width: panelRect.width, height: panelRect.height },
      { width: window.innerWidth, height: window.innerHeight },
      this.flipPositionAlign(),
      this.flipPositionMargin()
    );

    host.style.top = vertical === 'below' ? '100%' : 'auto';
    host.style.bottom = vertical === 'above' ? '100%' : 'auto';
    host.style.left = horizontal === 'left' ? '0' : 'auto';
    host.style.right = horizontal === 'right' ? '0' : 'auto';
  }
}
